import React, { useState } from 'react';
import AppShell from '../components/AppShell';
import { useAuth } from '../context/AuthContext';
import CorreiosSection from '../components/settings/CorreiosSection';
import MargemSection from '../components/settings/MargemSection';
import UsuariosSection from '../components/settings/UsuariosSection';
import IntegracaoSection from '../components/settings/IntegracaoSection';
import DashboardSection from '../components/settings/DashboardSection';
import RemetenteSection from '../components/settings/RemetenteSection';
import EmailSection from '../components/settings/EmailSection';
import PagamentosSection from '../components/settings/PagamentosSection';
import GoogleSection from '../components/settings/GoogleSection';
import RastreioExternoSection from '../components/settings/RastreioExternoSection';
import TabelaPrecosSection from '../components/settings/TabelaPrecosSection';

const TABS = [
  { id: 'painel', label: 'Painel', render: () => <DashboardSection /> },
  { id: 'remetente', label: 'Meus dados', render: () => <RemetenteSection /> },
  { id: 'correios', label: 'Integração Correios', render: () => <CorreiosSection /> },
  { id: 'tabela', label: 'Tabela de preços', render: () => <TabelaPrecosSection /> },
  { id: 'margem', label: 'Margem de lucro', render: () => <MargemSection /> },
  { id: 'usuarios', label: 'Usuários e permissões', render: () => <UsuariosSection /> },
  { id: 'integracao', label: 'Integração (gestão)', dono: true, render: () => <IntegracaoSection /> },
  { id: 'pagamentos', label: 'Pagamentos', render: () => <PagamentosSection /> },
  { id: 'rastreio', label: 'Rastreio (qualquer código)', render: () => <RastreioExternoSection /> },
  { id: 'email', label: 'E-mail', render: () => <EmailSection /> },
  { id: 'google', label: 'Login com Google', render: () => <GoogleSection /> },
];

const ConfiguracoesPage = () => {
  const { user } = useAuth();
  const [aba, setAba] = useState(null);
  const abas = user?.is_admin ? TABS.filter((t) => !t.dono || user.is_super_admin) : TABS.filter((t) => t.id === 'remetente');
  const atual = abas.find((t) => t.id === aba) || abas[0];

  return (
    <AppShell title="Configurações" subtitle="Tudo o que você configura e cria na plataforma">
      <div className="flex flex-wrap gap-2 mb-6">
        {abas.map((t) => (
          <button
            key={t.id} type="button" onClick={() => setAba(t.id)}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${atual.id === t.id ? 'bg-[#2A5BC7] text-white' : 'bg-white border border-slate-200 text-slate-600 hover:bg-slate-50'}`}
          >
            {t.label}
          </button>
        ))}
      </div>
      {atual.render()}
    </AppShell>
  );
};

export default ConfiguracoesPage;
